import '@fancyapps/fancybox';
import '../plugins/increment-field';

/* global script_l10n */

export default {
  init() {
    $('.form-primary .form-primary__input[type!="checkbox"]')
      .on('blur input focus', function () {
        const $this = $(this);
        const $field = $this.closest('.form-primary__group').find('.form-primary__placeholder');
        if ($this.val()) {
          $field.addClass('filled');
        } else {
          $field.removeClass('filled');
        }
      })
      .on('focus', function () {
        const $this = $(this);
        const $field = $this.closest('.form-primary__group').find('.form-primary__placeholder');
        $field.addClass('filled');
      });

    /* WooCommerce */
    function checkWCFields($row) {
      const $field = $row.closest('.form-row').find('label');
      if ($row.val()) {
        $field.addClass('filled');
      } else {
        $field.removeClass('filled');
      }
    }

    $('#customer_details .form-row, .woocommerce-form-login .form-row, .woocommerce-account .form-row')
      .find('input[type="text"], input[type="email"], input[type="tel"], input[type="password"], select')
      .each(function () {
        const $row = $(this);
        $row.on('blur input focus', function () {
          checkWCFields($row);
        });
        $row.on('focus', function () {
          const $field = $(this).closest('.form-row').find('label');
          $field.addClass('filled');
        });
        checkWCFields($row);
      });

    /* Increment fields */
    $('.summary.entry-summary input.qty').each(function () {
      $(this).IncrementField();
    });

    /* Show login box */
    $('a.showlogin')
      .off('click')
      .on('click', function () {
        $.fancybox.open({
          src: $('form.woocommerce-form-login'),
          type: 'inline'
        });
        return false;
      });

    /* Show recurring totals */
    $(document).on('click', '.recurring-totals th', function () {
      if ($('tr.recurring-total').is(':visible')) {
        $('tr.recurring-total').hide();
        $('body').removeClass('recurring-shown');
        $('.recurring-totals th').text(script_l10n.VIEW_RECURRING);
      } else {
        $('tr.recurring-total').fadeIn(250, function () {
          $('body').addClass('recurring-shown');
        });
        $('.recurring-totals th').text(script_l10n.HIDE_RECURRING);
      }
    });
  }
};
